module.exports = __webpack_public_path__ + "static/media/tank-fill-light.76f51fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tank-fill-light.png
// module id = 1138
// module chunks = 0